module.exports = __webpack_public_path__ + "img/image-roll-02.bbcaf25a.svg";